// --- BEGIN DATA ---
const formulasByBrand = {
   "Kendamil":[
      {
         "name":"Kendamil Comfort",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Comfort_18071bb2-674c-4f89-a7fb-6a233c1a3f64.jpg",
         "url":"https://organiclifestart.com/products/kendamil-comfort",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Inositol",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Whey Powder",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Soluble Dextrin",
            "Sunflower Oil",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Soluble Dextrin",
            "Cream (Milk)",
            "High Oleic Sunflower Oil",
            "Sunflower Oil",
            "Rapeseed Oil",
            "Coconut Oil",
            "Lactose (Milk)",
            "Partially Hydrolysed Whey Protein (Milk)",
            "Galacto-oligosaccharides (Milk)",
            "Whey Protein Concentrate Alpha-lactalbumin (Milk)",
            "Whole Milk Powder",
            "Calcium Phosphate",
            "Potassium Chloride",
            "Choline Bitartrate",
            "Oil from the microalgae Schizochytrium sp.",
            "Fructo-oligosaccharides",
            "Potassium Citrate",
            "Magnesium Sulphate",
            "Sodium Citrate",
            "L-tyrosine",
            "L-arginine",
            "Calcium Citrate",
            "Oil from Mortierella alpina",
            "Zinc Sulphate",
            "Sodium Ascorbate (Vitamin C)",
            "Inositol",
            "Iron Pyrophosphate",
            "Taurine",
            "Cytidine-5’-monophosphate",
            "disodium Uridine-5’-monophosphate",
            "Adenosine-5’-monophosphate",
            "disodium Inosine-5’-monophosphate",
            "disodium Guanosine-5’ monophosphate",
            "Sodium Selenite",
            "Copper Sulphate",
            "Vitamin E",
            "Potassium Iodide",
            "L-carnitine",
            "L-Histidine",
            "Niacin",
            "Vitamin D3",
            "Calcium Pantothenate",
            "Vitamin A",
            "Manganese Sulphate",
            "Biotin",
            "Riboflavin",
            "Thiamin",
            "Vitamin K",
            "Vitamin B6",
            "Folic Acid",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilComfortInfantMilk800g_UK_Ireland_1_1200x.jpg",
         "reviews_count":171,
         "stage":"Single",
         "brand_collection":"Kendamil Special"
      },
      {
         "name":"Kendamil Classic Stage 3 Toddler Cows Milk Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Classic_Stage_3.jpg",
         "url":"https://organiclifestart.com/products/kendamil-toddler-milk",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "Iron",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Lactose",
            "Algae Oil",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Sodium",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Whole Milk",
            "Lactose (from Milk)",
            "Skimmed Milk Powder",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Galacto-oligosaccharides (from Milk)",
            "Calcium phosphate",
            "Calcium Lactate",
            "Potassium Hydroxide",
            "LCP Oils (Oil from the Microalgae Schizochytrium sp.",
            "Oil from Mortierella Alpina",
            "Sodium Ascorbate",
            "Fructo-oligosaccharides",
            "Calcium Citrate",
            "Cytidine-5'-monophosphate",
            "Disodium Uridine-5'-monophosphate",
            "Adenosine-5'-monophosphate",
            "Disodium Inosine-5'-monophosphate",
            "Disodium Guanosine-5'-monophosphate",
            "Ferrous Sulfate",
            "Vitamin E",
            "Zinc Sulfate",
            "Niacin",
            "Calcium Pantothenate",
            "Copper Sulfate",
            "Vitamin A",
            "Thiamin",
            "Riboflavin",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Vitamin K",
            "Sodium Selenite",
            "Biotin",
            "Vitamin D3",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilStage3800g01_1200x.jpg",
         "reviews_count":182,
         "stage":"3",
         "brand_collection":"Kendamil UK Classic"
      },
      {
         "name":"Kendamil UK Classic Formula Stage 2",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Classic_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/kendamil-follow-on-milk",
         "ingredients":[
            "Nucleotides",
            "ARA",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "DHA",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Inositol",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Sodium",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Whole Milk",
            "Lactose (from Milk)",
            "Demineralized Milk Whey Powder (enriched in alpha lactalbumin)",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Galacto-oligosaccharides (from Milk)",
            "Skimmed Milk Powder",
            "Calcium Citrate",
            "Potassium Chloride",
            "Sodium Citrate",
            "Magnesium Chloride",
            "Potassium Hydroxide",
            "Docosahexaenoic Acid",
            "Sodium Ascorbate",
            "Inositol",
            "Arachidonic Acid",
            "Taurine",
            "Choline Bitartrate",
            "L Tyrosine",
            "Cytidine-5’-monophosphate",
            "disodium Uridine-5’-monophosphate",
            "Adenosine-5’-monophosphate",
            "disodium Inosine-5’-monophosphate",
            "disodium Guanosine-5’ monophosphate",
            "Iron Pyrophosphate",
            "L Phenylalanine",
            "L Carnitine",
            "Zinc Sulphate",
            "Vitamin E",
            "Niacin",
            "Calcium Pantothenate",
            "Copper Sulphate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulphate",
            "Folic Acid",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilStage2800g01_1200x.jpg",
         "reviews_count":193,
         "stage":"2",
         "brand_collection":"Kendamil UK Classic"
      },
      {
         "name":"Kendamil UK Classic Formula Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Classic_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/kendamil-first-infant-milk",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Amino Acids",
            "Iron",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Whole Milk",
            "Demineralised Whey Powder (from Milk)",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Lactose (from Milk)",
            "Galacto-oligosaccharides (from Milk)",
            "Skimmed Milk Powder",
            "Whey Protein Concentrate Alpha-actalbumin (from Milk)",
            "Calcium Citrate",
            "Potassium Chloride",
            "Calcium Lactate",
            "Sodium Citrate",
            "Choline Bitartrate",
            "Fructo-oligosaccharides",
            "Magnesium Chloride",
            "Oil from the Microalgae Schizochytrium sp.",
            "Sodium Ascorbate",
            "Potassium Hydroxide",
            "Inositol L-Tyrosine",
            "Oil from Mortierella Alpina",
            "Taurine",
            "Cytidine-5'-monophosphate",
            "Disodium Uridine-5-monophosphate",
            "Adenosine-5'-monophosphate",
            "Disodium Inosine-5-monophosphate",
            "Disodium Guanosine-5 monophosphate",
            "L-Phenylalanine",
            "Iron Pyrophosphate",
            "Zinc Sulfate",
            "Vitamin E",
            "Niacin",
            "Calcium Pantothenate",
            "Copper Sulfate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Potassium lodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilStage1800g01_1200x.jpg",
         "reviews_count":195,
         "stage":"1",
         "brand_collection":"Kendamil UK Classic"
      },
      {
         "name":"Kendamil Goat Toddler Formula Stage 3",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Goat_Stage_3_6b214a17-b89f-4909-a7d0-3f19410062f3.jpg",
         "url":"https://organiclifestart.com/products/kendamil-goat-toddler",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Coconut Oil",
            "Copper",
            "Iron",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Amino Acids",
            "Lactose",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Whole Goat Milk",
            "Demineralised Whey Powder (from Milk)",
            "Lactose (from Milk)",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Galacto-oligosaccharides (from Milk)",
            "Tri-Calcium Phosphate",
            "Calcium Lactate",
            "Calcium Citrate",
            "Calcium Phosphate",
            "Potassium Hydroxide",
            "Sodium Ascorbate",
            "Oil from the Microalgae Schizochytrium sp. (Milk)",
            "Ferrous Sulfate",
            "Oil from Mortierella Alpina (Milk)",
            "Cytidine-5'-monophosphate",
            "Disodium uridine-5'-monophosphate",
            "Adenosine-5'-monophosphate",
            "Disodium inosine-5-monophosphate",
            "Disodium guanosine-5-monophosphate",
            "L-Camitine",
            "Vitamin E",
            "Zinc Sulfate",
            "Niacin",
            "Calcium Pantothenate",
            "Copper Sulfate",
            "Vitamin A",
            "Thiamin",
            "Riboflavin",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilGoatStage301_b463f572-b473-4dd5-a079-3536658b17a4_1200x.jpg",
         "reviews_count":186,
         "stage":"3",
         "brand_collection":"Kendamil Goat"
      },
      {
         "name":"Kendamil Goat Stage 2",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Goat_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/kendamil-goat-stage-2",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Whey Powder",
            "Iron",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Whole Goat Milk",
            "Demineralised Goat Whey Powder (from Milk)",
            "sunflower oil",
            "Coconut oil",
            "Rapeseed oil",
            "Galacto-oligosaccharides (from Milk)",
            "Lactose (from Milk)",
            "Calcium Citrate",
            "Choline Bitartrate",
            "Potassium Chloride",
            "Calcium Lactate",
            "Sodium Citrate",
            "Magnesium Chloride",
            "Sodium Ascorbate",
            "Oil from the Microalgae Schizochytrium sp. (Milk)",
            "L-Tyrosine",
            "L-Phenylalanine",
            "L-Tryptophan",
            "Potassium Hydroxide",
            "Inositol",
            "Oil from Mortierella Alpina (Milk)",
            "L-Isoleucine",
            "Taurine",
            "Calcium Phosphate",
            "Ferrous Sulfate",
            "Cytidine-5'-monophosphate",
            "Disodium Uridine-5-monophosphate",
            "Adenosine-5'-monophosphate",
            "Disodium Inosine-5'-monophosphate",
            "Disodium Guanosine-5’-monophosphate",
            "L-Camitine",
            "Zinc Sulfate",
            "Vitamin E",
            "Niacin",
            "Calcium Pantothenate",
            "Copper Sulfate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilGoatStage201_fea12ed6-f580-4cd4-ab01-d647f7015471_1200x.jpg",
         "reviews_count":201,
         "stage":"2",
         "brand_collection":"Kendamil Goat"
      },
      {
         "name":"Kendamil Goat Milk Formula Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Goat_Stage_1_4db403f5-7bc3-4fff-abe5-34344928fdb2.jpg",
         "url":"https://organiclifestart.com/products/kendamil-goat-formula",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Whey Powder",
            "Iron",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Whole Goat Milk",
            "Demineralised Goat Whey Powder (from Milk)",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Galacto-oligosaccharides (from Milk)",
            "Lactose (from Milk)",
            "Calcium Citrate",
            "Choline Bitartrate",
            "Potassium Chloride",
            "Calcium Lactate",
            "Sodium Citrate",
            "Magnesium Chloride",
            "Sodium Ascorbate",
            "Oil from the Microalgae Schizochytrium sp. (Milk)",
            "L-Tyrosine",
            "L-Phenylalanine",
            "L-Tryptophan",
            "Potassium Hydroxide",
            "Inositol",
            "Oil from Morterella Alpina (Milk)",
            "L-Isoleucine",
            "Taurine",
            "Calcium Phosphate",
            "Ferrous Sulfate",
            "Cytidine-5-monophosphate",
            "Disodium Uridine-5'-monophosphate",
            "Adenosine-5'-monophosphate",
            "Disodium Inosine-5'-monophosphate",
            "Disodium Guanosine-5'-monophosphate",
            "L-Carnitine",
            "Zinc Sulfate",
            "Vitamin E",
            "Niacin",
            "Calcium Pantothenate",
            "Copper Sulfate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilGoatStage101_7f659edc-4311-44e4-83e7-276abe2cc6ad_1200x.jpg",
         "reviews_count":250,
         "stage":"1",
         "brand_collection":"Kendamil Goat"
      },
      {
         "name":"Kendamil Organic Stage 3 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Organic_Stage_3.jpg",
         "url":"https://organiclifestart.com/products/kendamil-stage-3",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "Iron",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Lactose",
            "Manganese",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Milk",
            "Organic Skimmed Milk",
            "Organic Lactose (from Milk)",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Organic Demineralised Milk",
            "Whey Protein Powder",
            "Organic Galacto-oligosaccharides (from Milk)",
            "Calcium Lactate",
            "Calcium Phosphate",
            "Potassium Hydroxide",
            "Vitamin C",
            "Calcium Citrate",
            "Oil from the Microalgae Schizochytrium sp.",
            "Potassium Chloride",
            "Ferrous Sulfate",
            "Vitamin E",
            "Zinc Sulfate",
            "Niacin",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Sodium Selenite",
            "Potassium Iodide",
            "Vitamin K",
            "Vitamin D3",
            "Biotine",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilOrganicStage301_1200x.jpg",
         "reviews_count":180,
         "stage":"3",
         "brand_collection":"Kendamil Organic"
      },
      {
         "name":"Kendamil Organic Stage 2 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Organic_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/kendamil-stage-2",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Mortierella Alpina Oil",
            "Iron",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Milk",
            "Organic Demineralised Milk Whey Protein Powder",
            "Organic Skimmed Milk",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Organic Galacto-oligosaccharides (from milk)",
            "Calcium Citrate",
            "Sodium Citrate",
            "Potassium Chloride",
            "Calcium Lactate",
            "Magnesium Chloride",
            "Oil from the Microalgae Schizochytrium sp.",
            "Vitamin C",
            "Potassium Hydroxide",
            "Choline Bitartrate",
            "Inositol Oil from Mortierella Alpina",
            "Taurine",
            "Cytidine-5’-monophosphate",
            "Disodium Uridine-5’-monophosphate",
            "Adenosine-5’-monophosphate",
            "Disodium Inosine-5‘-monophosphate",
            "Disodium Guanosine-5’-monophosphate",
            "Iron Pyrophosphate",
            "Zinc Sulfate",
            "Vitamin E",
            "Niacin",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilOrganicStage201_1200x.jpg",
         "reviews_count":204,
         "stage":"2",
         "brand_collection":"Kendamil Organic"
      },
      {
         "name":"Kendamil Organic Stage 1 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Kendamil_Organic_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/kendamil-organic-formula",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Cow Milk",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Mortierella Alpina Oil",
            "Iron",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Algae Oil",
            "Sodium",
            "Taurine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Milk",
            "Organic Demineralised Milk Whey Protein Powder",
            "Organic Skimmed Milk",
            "sunflower oil",
            "coconut oil",
            "rapeseed oil",
            "Organic Galacto-oligosaccharides (from milk)",
            "Calcium Citrate",
            "Sodium Citrate",
            "Potassium Chloride",
            "Calcium Lactate",
            "Magnesium Chloride",
            "Oil from the Microalgae Schizochytrium sp.",
            "Vitamin C",
            "Potassium Hydroxide",
            "Choline Bitartrate",
            "Inositol Oil from Mortierella Alpina",
            "Taurine",
            "Cytidine-5’-monophosphate",
            "Disodium Uridine-5’-monophosphate",
            "Adenosine-5’-monophosphate",
            "Disodium Inosine-5‘-monophosphate",
            "Disodium Guanosine-5’-monophosphate",
            "Iron Pyrophosphate",
            "Zinc Sulfate",
            "Vitamin E",
            "Niacin",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Thiamin",
            "Riboflavin",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/KendamilOrganicStage101_1200x.jpg",
         "reviews_count":241,
         "stage":"1",
         "brand_collection":"Kendamil Organic"
      }
   ],
   "Aptamil":[
      {
         "name":"Aptamil Comfort Baby Formula From Birth",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-comfort",
         "ingredients":[
            "Cow Milk",
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Glucose Syrup",
            "Sunflower Oil",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Starch",
            "Maltodextrin",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Taurine",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Whey Protein Hydrolysate (from Milk)",
            "Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "High Oleic Sunflower Oil",
            "Coconut Oil",
            "Glucose Syrup",
            "Galacto-Oligosaccharides (GOS) (from Milk)",
            "Maltodextrin",
            "Potato Starch",
            "Maize Starch",
            "Lactose (from Milk)",
            "Fructo-Oligosaccharides (FOS)",
            "Fish Oil",
            "Potassium Dihydrogen Phosphate",
            "Calcium Phosphate",
            "Calcium Chloride",
            "Choline Chloride",
            "Oil from Mortierella Alpina",
            "Magnesium Hydrogen Phosphate",
            "Potassium Chloride",
            "Sodium Chloride",
            "Vitamin C",
            "Inositol",
            "Taurine",
            "Ferrous Sulphate",
            "L-Carnitine",
            "Zinc Sulphate",
            "Uridine 5'-Monophosphate Sodium Salt",
            "Vitamin E",
            "Cytidine 5'-Monophosphate",
            "Pantothenic Acid",
            "Adenosine 5'-Monophosphate",
            "Inosine 5'-Monophosphate Sodium Salt",
            "Copper Sulphate",
            "Riboflavin",
            "Emulsifier (Soy Lecithin)",
            "Vitamin A",
            "Thiamin",
            "Vitamin B6",
            "Potassium Iodide",
            "Folic Acid",
            "Antioxidant (Ascorbyl Palmitate)",
            "Manganese Sulphate",
            "Sodium Selenite",
            "Vitamin K1",
            "Vitamin D3",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/Aptamil-Comfort-Baby-Milk-Formula-From-Birth-1_1200x.jpg",
         "reviews_count":21,
         "stage":"Single",
         "brand_collection":"Aptamil Special"
      },
      {
         "name":"Aptamil Anti Reflux Baby Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-ar",
         "ingredients":[
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Lactose",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Sunflower Oil",
            "Inositol",
            "Amino Acids",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Nicotinamide",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Taurine",
            "Thickener",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Dairy-Based Blend (of which 28% is Fermented) [Lactose (from Milk)",
            "Palm Oil",
            "Coconut Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "High Oleic Sunflower Oil",
            "Skimmed Milk",
            "Demineralised Whey (from Milk)",
            "Whey Concentrate (from Milk)",
            "Calcium Phosphate",
            "Fish Oil",
            "Choline Chloride",
            "Potassium Citrate",
            "Sodium Citrate",
            "Potassium Chloride",
            "Vitamin C",
            "Magnesium Chloride",
            "Emulsifier (Soy Lecithin)",
            "Inositol",
            "Calcium Carbonate",
            "L-Carnitine",
            "Vitamin E",
            "Antioxidant (Ascorbyl Palmitate)",
            "Pantothenic Acid",
            "Nicotinamide",
            "Thiamin",
            "Vitamin B6",
            "Riboflavin",
            "Folic Acid",
            "Potassium Iodide",
            "Vitamin K1",
            "Biotin",
            "Vitamin B12",
            "Galacto-Oligosaccharides (GOS) (from Milk)",
            "Thickener (Carob Bean Gum)",
            "Whey Protein (from Milk)",
            "Fructo-Oligosaccharides (FOS)",
            "Oil from Mortierella Alpina",
            "Taurine",
            "Ferrous Sulphate",
            "L-Tryptophan",
            "Zinc Sulphate",
            "Uridine 5'-Monophosphate Sodium Salt",
            "Cytidine 5'-Monophosphate",
            "Adenosine 5'-Monophosphate",
            "Inosine 5'-Monophosphate Sodium Salt",
            "Guanosine 5'-Monophosphate Sodium salt",
            "Copper Sulphate",
            "Vitamin E",
            "Vitamin A",
            "Manganese Sulphate",
            "Sodium Selenite",
            "Vitamin D3"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/Aptamil-Anti-Reflux-Baby-Milk-Formula-From-Birth_1200x.jpg",
         "reviews_count":17,
         "stage":"Single",
         "brand_collection":"Aptamil Special"
      },
      {
         "name":"Aptamil Pepti Stage 2 Extensively Hydrolyzed Hypoallergenic Follow On Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-pepti-2",
         "ingredients":[
            "Cow Milk",
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Nicotinamide",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Taurine",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Maltodextrin",
            "Hydrolysed Whey Protein Concentrate (from Milk*)",
            "Palm Oil",
            "Rapeseed Oil",
            "Coconut Oil",
            "Sunflower Oil",
            "Single Cell Oil",
            "Galacto-Oligosacchardies (from Milk*)",
            "Calcium Phosphate",
            "Emulsifier (Citric Acid Ester of Mono and Di-Glycerides)",
            "Fructo-Oligosaccharides",
            "Fish Oil",
            "Potassium Chloride",
            "Sodium Chloride",
            "Magnesium Hydrogen Phosphate",
            "Calcium Carbonate",
            "Vitamin C",
            "Choline Chloride",
            "Sodium Citrate",
            "Taurine",
            "Ferrous Sulphate",
            "Inositol",
            "Vitamin E",
            "Zinc Sulphate",
            "Uridine 5'-Monophosphate Sodium Salt",
            "Cytidine 5'-Monophosphate",
            "L-Carnitine",
            "Adenosine 5'-Monophosphate",
            "Inosine 5-'Monophosphate Sodium Salt",
            "Nicotinamide",
            "Pantothenic Acid",
            "Guanosine 5'-Monophosphate Sodium Salt",
            "Biotin",
            "Copper Sulphate",
            "Folic Acid",
            "Vitamin A",
            "Riboflavin",
            "Vitamin B12",
            "Thiamin",
            "Vitamin D3",
            "Vitamin B6",
            "Potassium Iodide",
            "Manganese Sulphate",
            "Vitamin B1",
            "Sodium Selenite"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/AptamilStage201_1200x.jpg",
         "reviews_count":98,
         "stage":"2",
         "brand_collection":"Aptamil Pepti"
      },
      {
         "name":"Aptamil Pepti Stage 1 Extensively Hydrolyzed Hypoallergenic Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-pepti-1",
         "ingredients":[
            "Cow Milk",
            "Nucleotides",
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Nicotinamide",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Taurine",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Hydrolysed Whey Protein Concentrate (from Milk*)",
            "Maltodextrin",
            "Palm Oil",
            "Rapeseed Oil",
            "Coconut Oil",
            "Sunflower Oil",
            "Single Cell Oil",
            "Galacto-Oligosaccharides (from Milk*)",
            "Emulsifier (Citric Acid Ester of Mono and Di-Glycerides)",
            "Fructo-Oligosaccharides",
            "Calcium Phosphate",
            "Fish Oil",
            "Potassium Chloride",
            "Sodium Citrate",
            "Magnesium Chloride",
            "Calcium Carbonate",
            "Vitamin C",
            "Choline Chloride",
            "Taurine",
            "Ferrous Sulphate",
            "Inositol",
            "Zinc Sulphate",
            "Uridine 5'-Monophosphate Sodium Salt",
            "Vitamin E",
            "Cytidine 5'-Monophosphate",
            "Adenosine 5'-Monophosphate",
            "Inosine 5'-Monophosphate Sodium Salt",
            "L-Carnitine",
            "Nicotinamide",
            "Pantothenic Acid",
            "Guanosine 5'-Monophosphate Sodium Salt",
            "Biotin",
            "Copper Sulphate",
            "Folic Acid",
            "Vitamin A",
            "Vitamin B12",
            "Thiamin",
            "Riboflavin",
            "Vitamin D3",
            "Vitamin B6",
            "Manganese Sulphate",
            "Potassium Iodide",
            "Vitamin K1",
            "Sodium Selenite"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/AptamilStage101_1200x.jpg",
         "reviews_count":94,
         "stage":"1",
         "brand_collection":"Aptamil Pepti"
      },
      {
         "name":"Aptamil Gold+ Stage 3 Pronutra Biotik Toddler Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/aptamil_gold_stage_3_1200x.jpg",
         "url":"https://organiclifestart.com/products/aptamil-gold-stage-3",
         "ingredients":[
            "Vitamin C",
            "Ascorbyl Palmitate",
            "Vitamin E",
            "Fish Oil",
            "Emulsifiers",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Vitamin A",
            "Iron",
            "Magnesium",
            "Maltodextrin",
            "Cow Milk",
            "Phosphorus",
            "Potassium",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B6",
            "Vitamin D3",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Milk solids",
            "maltodextrin",
            "contains emulsifier (soy lecithin)",
            "antioxidant (ascorbyl palmitate)",
            "short chain galac-to-oligosaccharides",
            "dried omega LCPUFAs",
            "contains fish oil",
            "sodium caseinate",
            "whey protein",
            "emulsifier (soy lecithin)",
            "antioxidant (sodium ascorbate)",
            "mixed tocopherols",
            "ascorbyl palmitate",
            "dl-alpha tocopherol",
            "long chain fructo-oligosaccharides",
            "potassium citrate",
            "Calcium",
            "phosphorus",
            "magnesium",
            "iron",
            "zinc",
            "iodine",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B6",
            "Vitamin B12",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "folic acid"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/aptamilgold3_1200x.jpg",
         "reviews_count":1,
         "stage":"3",
         "brand_collection":"Aptamil Gold"
      },
      {
         "name":"Aptamil Gold+ Stage 2 Pronutra Biotik Baby Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/aptamil_gold_stage_2_1200x.jpg",
         "url":"https://organiclifestart.com/products/aptamil-gold-stage-2",
         "ingredients":[
            "Nucleotides",
            "Vitamin C",
            "Ascorbyl Palmitate",
            "Bifidobacterium Breve M-16V",
            "Biotin",
            "Calcium",
            "Chloride",
            "Choline",
            "Copper",
            "Vitamin E",
            "Fish Oil",
            "Emulsifiers",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Potassium",
            "Iodine",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Manganese",
            "Cow Milk",
            "Phosphorus",
            "Vitamin A",
            "Sodium",
            "Taurine",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin D3",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Milk solids",
            "emulsifier (soy lecithin)",
            "antioxidant (ascorbyl palmitate)",
            "short chain galacto-oligosaccharides (milk)",
            "dried omega LCPUFAs",
            "fish oil",
            "sodium caseinate (milk)",
            "antioxidant",
            "sodium ascorbate",
            "mixed tocopherols",
            "ascorbyl palmitate",
            "dl-alpha tocopherol",
            "whey protein (milk)",
            "emulsifier (soy lecithin)",
            "long chain fructo-oligosaccharides",
            "taurine",
            "choline chloride",
            "Bifidobacterium breve M-16V",
            "L-carnitine",
            "inositol",
            "Potassium",
            "calcium",
            "chloride",
            "phosphorus",
            "sodium",
            "magnesium",
            "iron",
            "zinc",
            "copper",
            "iodine",
            "manganese",
            "selenium",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin B12",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K1",
            "folic acid",
            "biotin",
            "Cytidine-5’-monophosphate",
            "uridine-5’-monophosphate",
            "adenosine-5′-monophosphate",
            "inosine-5′-monophosphate",
            "guanosine-5′-monophosphate"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/aptamilgold2_1200x.jpg",
         "reviews_count":45,
         "stage":"2",
         "brand_collection":"Aptamil Gold"
      },
      {
         "name":"Aptamil Gold+ Stage 1 Pronutra Biotik Infant Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/aptamil_gold_stage_1_1200x.jpg",
         "url":"https://organiclifestart.com/products/aptamil-gold",
         "ingredients":[
            "Nucleotides",
            "Vitamin C",
            "Ascorbyl Palmitate",
            "Bifidobacterium Breve M-16V",
            "Biotin",
            "Calcium",
            "Chloride",
            "Choline",
            "Copper",
            "Vitamin E",
            "Fish Oil",
            "Emulsifiers",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Potassium",
            "Iodine",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Manganese",
            "Cow Milk",
            "Phosphorus",
            "Vitamin A",
            "Sodium",
            "Taurine",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin D3",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Milk solids",
            "emulsifier (soy lecithin)",
            "antioxidant (ascorbyl palmitate)",
            "short chain galacto-oligosaccharides (milk)",
            "dried omega LCPUFAs",
            "fish oil",
            "sodium caseinate (milk)",
            "antioxidant,",
            "sodium ascorbate",
            "mixed tocopherols",
            "ascorbyl palmitate",
            "dl-alpha tocopherol",
            "whey protein (milk)",
            "emulsifier (soy lecithin)",
            "long chain fructo-oligosaccharides",
            "taurine",
            "choline chloride",
            "Bifidobacterium breve M-16V",
            "L-carnitine",
            "inositol",
            "Potassium",
            "calcium",
            "chloride",
            "phosphorus",
            "sodium",
            "magnesium",
            "iron",
            "zinc",
            "copper",
            "iodine",
            "manganese",
            "selenium",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin B12",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K1",
            "folic acid",
            "biotin",
            "Cytidine-5’-monophosphate",
            "uridine-5’-monophosphate",
            "adenosine-5′-monophosphate",
            "inosine-5′-monophosphate",
            "guanosine-5′-monophosphate"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/aptamilgold1_1200x.jpg",
         "reviews_count":27,
         "stage":"1",
         "brand_collection":"Aptamil Gold"
      },
      {
         "name":"Aptamil Stage 3 Growing Up Milk Toddler Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-stage-3",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Lactose",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Sunflower Oil",
            "Inositol",
            "Magnesium",
            "Maltodextrin",
            "Nicotinamide",
            "Potassium",
            "Sodium",
            "Rapeseed Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Dairy-based blend (of which 25% is fermented) [Lactose (from milk)",
            "Skimmed milk",
            "Rapeseed oil",
            "Sunflower oil",
            "High oleic sunflower oil",
            "Coconut Oil",
            "Whey products (Demineralised whey",
            "Whey concentrate) (from milk)",
            "Calcium phosphate",
            "Calcium carbonate",
            "Fish oil",
            "Potassium citrate",
            "Sodium citrate",
            "Potassium chloride",
            "Vitamin C",
            "Emulsifier (Soy lecithin)",
            "Choline chloride",
            "Inositol",
            "Magnesium chloride",
            "Antioxidant (Vitamin C)",
            "Pantothenic acid",
            "Vitamin E",
            "Nicotinamide",
            "Riboflavin",
            "Vitamin B6",
            "Thiamin",
            "Potassium iodide",
            "Folic acid",
            "Vitamin K1",
            "Biotin",
            "Vitamin B12",
            "Maltodextrin",
            "Galacto-oligosaccharides (GOS) (from milk)",
            "Fructo-oligosaccharides (FOS)",
            "Magnesium hydrogen phosphate",
            "Ferrous sulphate",
            "Zinc sulphate",
            "Milk flavoring",
            "Vitamin A",
            "Vitamin D3"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/aptamil3_1200x.jpg",
         "reviews_count":56,
         "stage":"3",
         "brand_collection":"Aptamil"
      },
      {
         "name":"Aptamil Stage 2 Follow On Milk Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-2-formula",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Lactose",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Inositol",
            "Amino Acids",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Nicotinamide",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Dairy-based blend (of which 29% is fermented) [Lactose (from milk)",
            "High oleic sunflower oil",
            "Coconut oil",
            "Rapeseed oil",
            "Sunflower Oil",
            "Skimmed milk",
            "Demineralised whey (from milk)",
            "Whey concentrate (from milk)",
            "Calcium phosphate",
            "Fish oil",
            "Potassium chloride",
            "Potassium citrate",
            "Choline chloride",
            "Sodium citrate",
            "Vitamin C",
            "Calcium carbonate",
            "Emulsifier (Soy lecithin)",
            "Inositol",
            "Magnesium chloride",
            "Vitamin E",
            "Antioxidant (Vitamin C)",
            "Pantothenic acid",
            "Nicotinamide",
            "Thiamin",
            "Riboflavin",
            "Vitamin B6",
            "Folic acid",
            "Potassium iodide",
            "Vitamin K1",
            "Biotin",
            "Vitamin B12",
            "Galacto-oligosaccharides (GOS) (from milk)",
            "Fructo-oligosaccharides (FOS)",
            "Milk protein",
            "Magnesium hydrogen phosphate",
            "Oil from Mortierella Alpina",
            "Sodium chloride",
            "L-Tryptophan",
            "Ferrous sulphate",
            "Zinc sulphate",
            "L-Carnitine",
            "Copper sulphate",
            "Vitamin A",
            "Manganese sulphate",
            "Sodium selenite",
            "Vitamin D"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/aptamil2_1200x.jpg",
         "reviews_count":40,
         "stage":"2",
         "brand_collection":"Aptamil"
      },
      {
         "name":"Aptamil Stage 1 First Infant Milk From Birth Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/aptamil-first-infant-milk",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Coconut Oil",
            "Copper",
            "Lactose",
            "Emulsifiers",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Inositol",
            "Amino Acids",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Nicotinamide",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Dairy-based blend (of which 29% is fermented) [Lactose (from milk)",
            "High oleic sunflower oil",
            "Coconut oil",
            "Rapeseed oil",
            "Sunflower Oil",
            "Skimmed milk",
            "Demineralised whey (from milk)",
            "Whey concentrate (from milk)",
            "Fish oil",
            "Potassium citrate",
            "Calcium carbonate",
            "Magnesium chloride",
            "Choline chloride",
            "Calcium phosphate",
            "Sodium citrate",
            "Potassium chloride",
            "Vitamin C",
            "Emulsifier (Soy lecithin)",
            "Inositol",
            "Antioxidant (Vitamin C)",
            "Pantothenic acid",
            "Nicotinamide",
            "Vitamin E",
            "Thiamin",
            "Riboflavin",
            "Vitamin B6",
            "Potassium iodide",
            "Folic acid",
            "Vitamin K1",
            "Biotin",
            "Vitamin B12",
            "Galacto-oligosaccharides (GOS) (from milk)",
            "Milk protein",
            "Fructo-oligosaccharides (FOS)",
            "Oil from Mortierella Alpina",
            "Sodium chloride",
            "L-Tryptophan",
            "Ferrous sulphate",
            "Zinc sulphate",
            "L-Carnitine",
            "Copper sulphate",
            "Vitamin A",
            "Sodium selenite",
            "Manganese sulphate",
            "Vitamin D3"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/aptamil1_1200x.jpg",
         "reviews_count":33,
         "stage":"1",
         "brand_collection":"Aptamil"
      }
   ],
   "HiPP":[
      {
         "name":"HiPP UK Comfort Formula Combiotic From Birth",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/hipp-comfort-formula-uk",
         "ingredients":[
            "Cow Milk",
            "Beta-Palmitate",
            "Calcium",
            "Choline",
            "Copper",
            "Citric Acid",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Lactose",
            "maltodextrin",
            "palm oil",
            "rapeseed oil",
            "sun_ower Oil",
            "starch",
            "Beta-palmitate (From Palm Oil And Sunflower Oil)",
            "hydrolysed whey protein",
            "galacto-oligosaccharides from lactose",
            "calcium salts of orthophosphoric acid",
            "emulsifier citric acid esters of mono and diglycerides of fatty acids",
            "potassium chloride",
            "fish oil",
            "choline",
            "Mortierella alpina-oil",
            "L-phenylalanine",
            "L-tyrosine",
            "potassium hydroxide",
            "magnesium carbonate",
            "sodium citrate",
            "sodium hydroxide",
            "sodium selenite",
            "L-tryptophan",
            "vitamin C",
            "calcium carbonate",
            "L-histidine",
            "zinc sulphate",
            "calcium chloride",
            "inositol",
            "potassium iodate",
            "ferrous sulphate",
            "L-carnitine",
            "vitamin E",
            "pantothenic acid",
            "niacin",
            "cupric sulphate",
            "vitamin B1",
            "vitamin A",
            "vitamin B2",
            "manganese sulphate",
            "vitamin B6",
            "folic acid",
            "vitamin K",
            "D-biotin",
            "vitamin D",
            "vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPUKComfort02_1200x.jpg",
         "reviews_count":35,
         "stage":"Single",
         "brand_collection":"HiPP UK Special"
      },
      {
         "name":"HiPP HA Dutch Stage 2",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_HA_Dutch_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/hipp-ha-dutch-stage-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Citric Acid",
            "Fish Oil",
            "Whey Powder",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Magnesium",
            "Manganese",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products. Milk proteins have been hydrolyzed.",
         "original_ingredients":[
            "Lactose",
            "palm oil",
            "rapeseed oil",
            "sunflower Oil",
            "hydrolyzed whey proteins",
            "lactose galacto-oligosaccharides",
            "calcium orthophosphate",
            "potassium chloride",
            "emulsifying agent: citric acid esters of mono and diglycerides",
            "potassium chloride",
            "emulsifying agent: citric acid esters of mono and diglycerides of fatty acids",
            "fish oil",
            "potassium hydroxide",
            "sodium hydroxide",
            "calcium carbonate",
            "L-phenylalanine",
            "L-tyrosine",
            "magnesium carbonate",
            "sodium selenite",
            "vitamin C",
            "L-tryptophan",
            "zinc sulfate",
            "L-histidine",
            "iron sulfate",
            "potassium iodate",
            "niacin",
            "L-tryptophan acid",
            "zinc sulfate",
            "L-histidine",
            "iron sulfate",
            "potassium iodate",
            "niacin",
            "pantothenic acid",
            "natural culture of lactic acid (Limosilactobacillus fermentum hereditum)",
            "vitamin E",
            "copper sulphate",
            "vitamin B2",
            "vitamin B1",
            "vitamin A",
            "vitamin B6",
            "manganese sulphate",
            "calcium-L-methylfolate3",
            "biotin",
            "vitamin K",
            "vitamin D",
            "vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPHAStage2800g01_1200x.jpg",
         "reviews_count":98,
         "stage":"2",
         "brand_collection":"HiPP Dutch HA"
      },
      {
         "name":"HiPP HA Dutch Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_HA_Dutch_Stage_1_bdb505d1-a398-4484-8600-6b360ab1093b.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-ha-hydrolyzed-formula-stage-1",
         "ingredients":[
            "Calcium",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Amino Acids",
            "Lactic Acid",
            "Lactose",
            "Magnesium",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B",
            "Vitamin B12",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products. Milk proteins have been hydrolyzed.",
         "original_ingredients":[
            "Skimmed Milk",
            "Lactose",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Galacto-oligosaccharides from Lactose",
            "Potassium Citrate",
            "Calcium Salts of Orthophosphoric Acid",
            "Calcium Salts of Citric Acid",
            "Magnesium Sulfate",
            "Fish Oil",
            "Vitamin C (Sodium L-ascorbate)",
            "Zinc Sulfate",
            "Ferrous Sulfate",
            "Lactic Acid Stabilizer",
            "Natural Lactic Ferments (Limosilactobacillus Fermentum Hereditum)",
            "Vitamin B (Riboflavin)",
            "Vitamin A (Retinyl Acetate)",
            "Potassium Iodate",
            "Calcium",
            "L-methylfolate",
            "D-biotin",
            "Vitamin D (Cholecalciferol)",
            "Vitamin B12 (Cyanocobalamin)"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPHAStage1800g01_1200x.jpg",
         "reviews_count":88,
         "stage":"1",
         "brand_collection":"HiPP Dutch HA"
      },
      {
         "name":"HiPP Dutch Stage 4 Junior Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Dutch_Stage_4_521f55b1-64a6-4a43-8d7e-d31917ade263.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-stage-4",
         "ingredients":[
            "Vitamin D3",
            "Calcium",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Lactose",
            "Magnesium",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin C",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Skimmed milk",
            "lactose",
            "Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Galacto-oligosaccharides from Lactose",
            "Potassium Citrate",
            "Calcium Salts of Orthophosphoric Acid",
            "Calcium Salts of Citric Acid",
            "Magnesium Sulfate",
            "Fish Oil",
            "Vitamin C (Sodium L-Ascorbate)",
            "Zinc Sulfate",
            "Iron Sulfate",
            "Natural Lactic Acid Culture (Limosillactobacillus Fermentum Hereditum)",
            "Vitamin B (Riboflavin)",
            "Vitamin A (Retinyl Acetate)",
            "Potassium Iodate",
            "Calcium L-Methylfolate D-biotin",
            "Vitamin D (Cholecalciferol)",
            "Vitamin B1 (Cyanocobalamin)"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPJuinorCombiotik401_1200x.jpg",
         "reviews_count":72,
         "stage":"4",
         "brand_collection":"HiPP Dutch"
      },
      {
         "name":"HiPP Dutch Goat Stage 3 Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/hipp-dutch-goat-stage-3-formula",
         "ingredients":[
            "Calcium",
            "Copper",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Goat's milk",
            "lactose",
            "palm oil",
            "rapeseed oil",
            "sunflower Oil",
            "goat's milk powder",
            "galacto-oligosaccharides* from lactose",
            "calcium carbonate",
            "fish oil",
            "sodium citrate",
            "potassium citrate",
            "vitamin C",
            "ferrous sulfate",
            "magnesium carbonate",
            "L-tryptophan",
            "L-tyrosine",
            "L-cystine",
            "zinc sulfate",
            "copper sulfate",
            "vitamin E",
            "pantothenic acid (calcium-D-pantothenate)",
            "niacin (nicotinamide)",
            "vitamin A",
            "vitamin B1",
            "vitamin B6",
            "manganese sulfate",
            "folic acid",
            "sodium selenite",
            "potassium iodide",
            "vitamin K",
            "D-biotin",
            "vitamin D (cholecalciferol)",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPDutchGoatStage301_1200x.jpg",
         "reviews_count":85,
         "stage":"3",
         "brand_collection":"HiPP Dutch Goat"
      },
      {
         "name":"HiPP Dutch Goat Stage 2 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Dutch_Goat_Stage_2_83a34337-1b1b-4510-bef5-c8acb4bd2fcf.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-goat-stage-2-formula",
         "ingredients":[
            "Calcium",
            "Copper",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Goat's milk",
            "lactose",
            "palm oil",
            "rapeseed oil",
            "sunflower Oil",
            "goat's milk powder",
            "galacto-oligosaccharides from lactose",
            "calcium carbonate",
            "fish oil",
            "potassium citrate",
            "vitamin C",
            "sodium citrate",
            "ferrous sulphate",
            "L-tyrosine",
            "L-tryptophan",
            "L-cystine",
            "magnesium carbonate",
            "zinc sulfate",
            "copper sulfate",
            "niacin (nicotinamide)",
            "vitamin E",
            "pantothenic acid (calcium D-pantothenate)",
            "vitamin A",
            "vitamin B1",
            "vitamin B6",
            "manganese sulfate",
            "folic acid",
            "sodium selenite",
            "vitamin K",
            "potassium iodide",
            "vitamin D",
            "D-biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPDutchGoatStage201_1200x.jpg",
         "reviews_count":124,
         "stage":"2",
         "brand_collection":"HiPP Dutch Goat"
      },
      {
         "name":"HiPP Dutch Goat Stage 1 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Dutch_Goat_Stage_1_9497eee6-09ee-435f-86fb-3c4fc616f915.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-goat-stage-1-formula",
         "ingredients":[
            "Calcium",
            "Choline",
            "Copper",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Goat's milk",
            "lactose",
            "palm oil",
            "rapeseed oil",
            "sunflower Oil",
            "goat's milk powder",
            "galacto-oligosaccharides* from lactose",
            "fish oil",
            "choline",
            "calcium carbonate",
            "Mortierella alpina oil",
            "L-tyrosine",
            "sodium citrate",
            "vitamin C",
            "L-tryptophan",
            "L-cystine",
            "zinc sulfate",
            "iron sulfate",
            "copper sulfate",
            "niacin (nicotinamide)",
            "pantothenic acid (calcium D-pantothenate)",
            "vitamin E",
            "vitamin A",
            "vitamin B",
            "vitamin B6",
            "folic acid",
            "vitamin K",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin D",
            "D-Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPDutchGoatStage101_86b98385-67f0-4999-9014-036115899d80_1200x.jpg",
         "reviews_count":121,
         "stage":"1",
         "brand_collection":"HiPP Dutch Goat"
      },
      {
         "name":"HiPP German Stage 2 - No Starch - Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_German_Stage_2_-_No_Starch.jpg",
         "url":"https://organiclifestart.com/products/hipp-german-stage-2-no-starch",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Lactic Acid",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Lactose",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Whey Product",
            "Organic Galacto-oligosaccharides from Organic Lactose",
            "Organic Fish Oil",
            "Calcium Orthophosphates",
            "Potassium Chloride",
            "Sodium Selenite",
            "L-Tyrosine",
            "Zinc Sulfate",
            "L-Tryptophan",
            "Sodium Citrate",
            "Calcium Carbonate",
            "Magnesium Carbonate",
            "Vitamin C",
            "Iron Sulfate",
            "Stabilizer Lactic Acid",
            "L-Cystine",
            "Potassium Iodate",
            "Niacin",
            "Natural Lactic Acid Cultures (Limosilactobacillus Fermentum Hereditum)",
            "Vitamin E",
            "Manganese Sulfate",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Metafolin (Calcium L-Methylfolate)",
            "Vitamin K",
            "Vitamin D",
            "Biotin"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPBioCombiotik202_40cd134a-fb1c-4778-8dd5-f0caa86f6a16_1200x.jpg",
         "reviews_count":377,
         "stage":"2",
         "brand_collection":"HiPP German"
      },
      {
         "name":"HiPP German Stage PRE Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_German_Stage_PRE.jpg",
         "url":"https://organiclifestart.com/products/hipp-bio-combiotik-pre",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactic Acid",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Mortierella Alpina Oil",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Whey Product",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Lactose",
            "Galacto-oligosaccharides from Lactose",
            "Fish Oil",
            "Potassium Chloride",
            "M. Alpina Oil",
            "Choline",
            "Sodium Citrate",
            "L-phenylalanine",
            "Calcium Orthophosphate",
            "Sodium Selenite",
            "Zinc Sulfate",
            "Calcium Carbonate",
            "Magnesium Sulfate",
            "L-tryptophan",
            "L-Histidine",
            "Iron Sulfate",
            "Potassium Iodate",
            "Lactic Acid Stabilizer",
            "Vitamin C",
            "Natural Lactic Acid Cultures (Limosilactobacillus Fermentum Hereditum)",
            "Vitamin E",
            "Niacin",
            "Pantothenic Acid",
            "Manganese Sulfate",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B",
            "Metafolin (Calcium L-methylfolate)",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPGermanStagePRECombioticOrganicBabyFormula02_1200x.jpg",
         "reviews_count":388,
         "stage":"Pre",
         "brand_collection":"HiPP German"
      },
      {
         "name":"Hipp 1+ Kindermilch Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Hipp_1_Kindermilch.jpg",
         "url":"https://organiclifestart.com/products/hipp-kindermilch-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Lactic Acid",
            "Lactose",
            "Magnesium",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin C",
            "Vitamin D3",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Lactose",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Galacto-oligosaccharides from Lactose",
            "Potassium Citrate",
            "Calcium Orthophosphates",
            "Calcium Citrates",
            "Magnesium Sulfate",
            "Fish Oil",
            "Copper Sulfate",
            "Vitamin C",
            "Iron Sulfate",
            "Lactic Acid Stabilizer",
            "Zinc Sulfate",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Vitamin B2",
            "Vitamin A",
            "Potassium Iodate",
            "Folic Acid",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPKindermilchCombiotik102_1200x.jpg",
         "reviews_count":81,
         "stage":"4",
         "brand_collection":"HiPP German"
      },
      {
         "name":"Hipp 2+ Years Combiotic Kindermilch Toddler Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Hipp_2_Kindermilch.jpg",
         "url":"https://organiclifestart.com/products/hipp-kindermilch-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Lactic Acid",
            "Lactose",
            "Magnesium",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin C",
            "Vitamin D3",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Lactose",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Galacto-oligosaccharides from Lactose",
            "Potassium Citrate",
            "Calcium Orthophosphates",
            "Calcium Citrates",
            "Magnesium Sulfate",
            "Fish Oil",
            "Vitamin C",
            "Iron Sulfate",
            "Lactic Acid Stabilizer",
            "Zinc Sulfate",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Vitamin B2",
            "Vitamin A",
            "Potassium Iodate",
            "Folic Acid",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPKindermilchCombiotik202_1200x.jpg",
         "reviews_count":82,
         "stage":"4",
         "brand_collection":"HiPP German"
      },
      {
         "name":"HiPP Comfort Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Comfort.jpg",
         "url":"https://organiclifestart.com/products/hipp-comfort",
         "ingredients":[
            "Cow Milk",
            "Beta-Palmitate",
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Citric Acid",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Metafolin",
            "Mortierella Alpina Oil",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Lactose",
            "Maltodextrin",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Starch",
            "Beta-palmitate (From Palm Oil And Sunflower Oil)",
            "Hydrolyzed Whey Protein",
            "Galactooligosaccharides From Lactose",
            "Calcium Orthophosphates",
            "Emulsifier Citric Acid Esters Of Mono And Diglycerides Of Fatty Acids",
            "Potassium Chloride",
            "Fish Oil",
            "Choline",
            "M. Alpina Oil",
            "L-Phenylalanine",
            "L-Tyrosine",
            "Potassium Hydroxide",
            "Magnesium Chloride",
            "Sodium Citrate",
            "Sodium Hydroxide",
            "L-Arginine",
            "Calcium Carbonate",
            "L-Histidine",
            "Calcium Chloride",
            "L-Tryptophan",
            "Inositol",
            "Ferrous Sulfate",
            "L-Carnitine",
            "Zinc Oxide",
            "Pantothenic Acid",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B2",
            "Vitamin B1",
            "Potassium Iodate",
            "Vitamin B6",
            "Metafolin (Calcium L-Methylfolate)",
            "Sodium Selenate",
            "Vitamin K",
            "Biotin",
            "Vitamin D",
            "Manganese Sulfate",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPComfort60002_1200x.jpg",
         "reviews_count":433,
         "stage":"Single",
         "brand_collection":"HiPP Special"
      },
      {
         "name":"HiPP Anti Reflux AR Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_AR_d6c26e85-befa-436b-96a5-381d925d91ad.jpg",
         "url":"https://organiclifestart.com/products/hipp-anti-reflux-formula",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Lactose",
            "Magnesium",
            "Metafolin",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin C",
            "Vitamin D3",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Skim Milk",
            "Lactose",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Galactooligosaccharides From Lactose",
            "Potassium Citrate",
            "Calcium Orthophosphates",
            "Calcium Citrates",
            "Magnesium Sulfate",
            "Fish Oil",
            "Vitamin C",
            "Ferrous Sulfate",
            "Stabilizer Lactic Acid",
            "Zinc Sulfate",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Vitamin B2",
            "Vitamin A",
            "Potassium Iodate",
            "Metafolin (Calcium L-Methylfolate)",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPAntiReflux60005_1200x.jpg",
         "reviews_count":436,
         "stage":"Single",
         "brand_collection":"HiPP Special"
      },
      {
         "name":"HiPP HA PRE Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_HA_Stage_PRE.jpg",
         "url":"https://organiclifestart.com/products/hipp-ha-pre",
         "ingredients":[
            "Cow Milk",
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Citric Acid",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Mortierella Alpina Oil",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products. Milk proteins have been hydrolyzed.",
         "original_ingredients":[
            "Lactose",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Whey Protein Hydrolysate",
            "Galactooligosaccharides From Lactose",
            "Calcium Orthophosphates",
            "Potassium Chloride",
            "M. Alpina Oil",
            "Fish Oil",
            "Emulsifier: Citric Acid Esters Of Mono AND Diglycerides Of Edible Fatty Acids",
            "Potassium Hydroxide",
            "Sodium Hydroxide",
            "L-Tyrosine",
            "L-Phenylalanine",
            "Magnesium Carbonate",
            "Choline",
            "Calcium Carbonate",
            "Vitamin C",
            "L-Tryptophan",
            "Inositol",
            "Ferrous Sulfate",
            "Zinc Sulfate",
            "L-Carnitine",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Pantothenic Acid",
            "Vitamin A",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodate",
            "Metafolin (Calcium L-Methylfolate)",
            "Vitamin K",
            "Sodium Selenate",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPHAStagePRE02_1200x.jpg",
         "reviews_count":434,
         "stage":"Pre",
         "brand_collection":"HiPP HA"
      },
      {
         "name":"HiPP HA Stage 2 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_HA_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/hipp-ha-stage-2",
         "ingredients":[
            "Cow Milk",
            "Biotin",
            "Calcium",
            "Copper",
            "Citric Acid",
            "Iron",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Metafolin",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products. Milk proteins have been hydrolyzed.",
         "original_ingredients":[
            "Lactose",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Hydrolyzed Whey Protein",
            "Galactooligosaccharides From Lactose",
            "Calcium Orthophosphates",
            "Potassium Chloride",
            "Emulsifier: Citric Acid Esters Of Mono And Diglycerides Of Edible Fatty Acids",
            "L-Tyrosine",
            "Potassium Hydroxide",
            "Sodium Hydroxide",
            "Calcium Citrate",
            "Vitamin C",
            "Magnesium Carbonate",
            "Potassium Citrate",
            "Magnesium Sulfate",
            "L-Tryptophan",
            "Calcium Carbonate",
            "Ferrous Sulfate",
            "Zinc Sulfate",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Pantothenic Acid",
            "Vitamin A",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B6",
            "Potassium Iodate",
            "Metafolin (Calcium L-Methylfolate)",
            "Vitamin K",
            "Sodium Selenate",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPHAStage202_1200x.jpg",
         "reviews_count":425,
         "stage":"2",
         "brand_collection":"HiPP HA"
      },
      {
         "name":"HiPP HA Formula Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_HA_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/hipp-ha-stage-1",
         "ingredients":[
            "Cow Milk",
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Citric Acid",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Whey Powder",
            "Inositol",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Mortierella Alpina Oil",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products. Milk proteins have been hydrolyzed.",
         "original_ingredients":[
            "Lactose",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Whey Protein Hydrolysate",
            "Galactooligosaccharides From Lactose",
            "Calcium Orthophosphates",
            "Potassium Chloride",
            "Emulsifier: Citric Acid Esters Of Mono AND Diglycerides Of Fatty Acids",
            "M. Alpina Oil",
            "Fish Oil",
            "L-Tyrosine",
            "L-Phenylalanine",
            "Potassium Hydroxide",
            "Sodium Hydroxide",
            "Vitamin C",
            "Magnesium Carbonate",
            "Choline",
            "L-Tryptophan",
            "Calcium Carbonate",
            "Inositol",
            "Ferrous Sulfate",
            "Zinc Sulfate",
            "L-Carnitine",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Pantothenic Acid",
            "Vitamin A",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodate",
            "Metafolin (Calcium L-Methylfolate)",
            "Vitamin K",
            "Sodium Selenate",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPHAStage102_aefb40d6-9ae8-442c-b831-7d89adb2cfcc_1200x.jpg",
         "reviews_count":431,
         "stage":"1",
         "brand_collection":"HiPP HA"
      },
      {
         "name":"HiPP German Stage 3 Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_German_Stage_3.jpg",
         "url":"https://organiclifestart.com/products/hipp-stage-3-german",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Emulsifiers",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Lactic Acid",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Lactose",
            "Organic Starch",
            "Organic Whey Product",
            "Organic Galacto-oligosaccharides from Organic Lactose",
            "Organic Fish Oil",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Calcium Orthophosphates",
            "Emulsifier Lecithins",
            "Sodium Selenite",
            "Zinc Sulfate",
            "Sodium Citrate",
            "L-tryptophan",
            "Magnesium Carbonate",
            "Vitamin C",
            "Iron Sulfate",
            "L-Cystine",
            "Potassium Iodate",
            "Natural Lactic Acid Culture (Limosilactobacillus Fermentum Hereditu)",
            "Vitamin E",
            "Niacin",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Metafolin (Calcium L-Methylfolate)",
            "Manganese Sulfate",
            "Vitamin K",
            "Vitamin D",
            "Biotin"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPGermanStage302_1200x.jpg",
         "reviews_count":380,
         "stage":"3",
         "brand_collection":"HiPP German"
      },
      {
         "name":"HiPP German Stage 2 Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_German_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/hipp-stage-2-german",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "DHA",
            "Emulsifiers",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Lactic Acid",
            "Palm Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Whey Product",
            "Organic Lactose",
            "Organic Starch",
            "Organic Galacto-oligosaccharides from Organic Lactose",
            "Organic Fish Oil",
            "Calcium Carbonate",
            "Emulsifier Lecithins",
            "Sodium Selenite",
            "L-tyrosine",
            "Zinc Sulfate",
            "L-Tryptophan",
            "Magnesium Carbonate",
            "Vitamin C",
            "Iron Sulfate",
            "L-cystine",
            "Potassium Iodate",
            "Sodium CitratE",
            "Natural Lactic Acid Cultures (Limosilactobacillus fermentum hereditum)",
            "Vitamin E",
            "Niacin",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Manganese Sulfate",
            "Metafolin (Calcium L-Methylfolate)",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Organic DHA"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPBioCombiotik202_1200x.jpg",
         "reviews_count":413,
         "stage":"2",
         "brand_collection":"HiPP German"
      },
      {
         "name":"HiPP German Stage 1 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_German_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/hipp-german-stage-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Mortierella Alpina Oil",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Whey Product",
            "Organic Palm Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Starch",
            "Galactooligosaccharides* From Lactose",
            "Lactose",
            "Fish Oil",
            "Calcium Chloride",
            "Potassium Citrate",
            "M. Alpina Oil",
            "Choline",
            "L-Tyrosine",
            "Sodium Citrate",
            "Calcium Carbonate",
            "L-Tryptophan",
            "Zinc Sulfate",
            "Ferrous Sulfate",
            "L-Histidine",
            "Stabilizer Lactic Acid",
            "Calcium Orthophosphates",
            "Vitamin C",
            "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)",
            "Niacin",
            "Vitamin E",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Magnesium Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Potassium Iodate",
            "Metafolin (Calcium L-Methylfolate)",
            "Vitamin B6",
            "Sodium Selenate",
            "Vitamin K",
            "Manganese Sulfate",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HiPPBioCombiotik102_ff8c8ea7-2a9e-4d7b-b00c-63e0185aed14_1200x.jpg",
         "reviews_count":416,
         "stage":"1",
         "brand_collection":"HiPP German"
      },
      {
         "name":"HiPP UK Stage 3 Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/hipp-uk-stage-3",
         "ingredients":[
            "Calcium",
            "Copper",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic skimmed milk",
            "organic lactose",
            "organic palm oil",
            "organic rapeseed oil",
            "organic sunflower Oil",
            "organic galacto-oligosaccharides from organic lactose",
            "fish oil",
            "potassium citrate",
            "calcium salts of orthophosphoric acid",
            "calcium carbonate",
            "sodium citrate",
            "potassium chloride",
            "vitamin C",
            "magnesium carbonate",
            "L-tryptophan",
            "ferrous sulphate",
            "zinc sulphate",
            "vitamin E",
            "niacin",
            "pantothenic acid",
            "cupric sulphate",
            "vitamin B1",
            "vitamin A",
            "vitamin B6",
            "folic acid calcium-L-methyfolate (Metafolin)",
            "potassium iodate",
            "sodium selenite",
            "vitamin K",
            "D-biotin",
            "vitamin D",
            "manganese sulphate",
            "vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPUKDutch301_1_1200x.jpg",
         "reviews_count":117,
         "stage":"3",
         "brand_collection":"HiPP UK"
      },
      {
         "name":"HiPP UK Stage 2 Organic Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/hipp-uk-stage-2",
         "ingredients":[
            "Calcium",
            "Copper",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Lactose",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Whey Product",
            "Organic Galacto-oligosaccharides from Organic Lactose",
            "Fish Oil",
            "Potassium Chloride",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Tyrosine",
            "Calcium Carbonate",
            "L-Tryptophan",
            "Sodium Citrate",
            "Magnesium Carbonate",
            "Vitamin C",
            "Ferrous Sulfate",
            "L-Cystine",
            "Niacin",
            "Zinc Sulfate",
            "Vitamin E",
            "Pantothenic Acid",
            "Cupric Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Potassium Iodate",
            "Folic Acid",
            "Sodium Selenite",
            "Manganese Sulfate",
            "Vitamin K",
            "Vitamin D",
            "D-biotin"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPUKDutch201_1_1200x.jpg",
         "reviews_count":160,
         "stage":"2",
         "brand_collection":"HiPP UK"
      },
      {
         "name":"HiPP UK Stage 1 Organic Formula",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/hipp-uk-stage-1",
         "ingredients":[
            "Cow Milk",
            "Calcium",
            "Choline",
            "Copper",
            "Iron",
            "Fish Oil",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic skimmed",
            "organic whey product",
            "organic palm oil",
            "organic rapeseed oil",
            "organic sunflower Oil",
            "organic lactose",
            "organic galacto-oligosaccharides from organic lactose",
            "potassium chloride",
            "fish oil",
            "Mortierella alpina-oil",
            "choline",
            "sodium citrate",
            "L-phenylalanine",
            "calcium salts of orthophosphoric acid",
            "L-tryptophan",
            "magnesium carbonate",
            "calcium carbonate",
            "L-histidine",
            "zinc sulphate",
            "ferrous sulphate",
            "vitamin C",
            "vitamin E",
            "niacin",
            "pantothenic acid",
            "cupric sulphate",
            "vitamin A",
            "vitamin B1",
            "potassium iodate",
            "vitamin B6",
            "folic acid calcium-L-methyfolate (Metafolin)",
            "sodium selenite",
            "vitamin K",
            "manganese sulphate",
            "vitamin D",
            "D-biotin",
            "vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPUKDutch101_3_1200x.jpg",
         "reviews_count":179,
         "stage":"1",
         "brand_collection":"HiPP UK"
      },
      {
         "name":"HiPP Dutch Stage 3 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Dutch_Stage_3.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-stage-3",
         "ingredients":[
            "Calcium",
            "Copper",
            "Iron",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Lactic Acid",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Skimmed milk",
            "lactose",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Galacto-oligosaccharides from Organic Lactose",
            "Fish Oil",
            "Potassium Citrate",
            "Calcium Salts of Orthophosphoric Acid",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Sodium Citrate",
            "Magnesium Carbonate",
            "Sodium Selenite",
            "Zinc Sulfate",
            "L-Tryptophan",
            "Vitamin C",
            "Ferrous Sulfate",
            "Potassium Iodate",
            "Vitamin E",
            "Natural Lactic Ferments (Limosilactobacillus Fermentum Hereditum)",
            "Niacin",
            "Pantothenic Acid",
            "Cupric Sulfate",
            "Manganese Sulfate",
            "Vitamin B1",
            "Vitamin A",
            "Vitamin B",
            "Calcium-L-Methylfolate",
            "Vitamin K",
            "D-Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPDutchStage301_1200x.jpg",
         "reviews_count":406,
         "stage":"3",
         "brand_collection":"HiPP Dutch"
      },
      {
         "name":"HiPP Dutch Stage 2 Combiotic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Dutch_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-stage-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactic Acid",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Lactose",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Whey",
            "Organic Galacto-Oligosaccharides (obtained from Organic Lactose)",
            "Fish Oil",
            "Calcium Chloride",
            "Potassium Citrate",
            "Calcium Salts Of Orthophosphoric Acid",
            "Calcium Carbonate",
            "L-Tyrosine",
            "L-Tryptophan",
            "Sodium Citrate",
            "Magnesium Carbonate",
            "Vitamin C",
            "Iron Sulfate",
            "Lactic Acid",
            "L-Cystine",
            "Niacin",
            "Zinc Oxide",
            "Lactic Acid Culture [Hereditum Lactobacillus Fermentum CECT5716]",
            "Vitamin E",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Potassium Iodate",
            "Metafolin (Calcium L-Methylfolate)",
            "Sodium Selenate",
            "Manganese Sulfate",
            "Vitamin K",
            "Vitamin D",
            "Biotin"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPDutchStage201_1200x.jpg",
         "reviews_count":458,
         "stage":"2",
         "brand_collection":"HiPP Dutch"
      },
      {
         "name":"HiPP Dutch Stage 1 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/HiPP_Dutch_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/hipp-dutch-stage-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Fish Oil",
            "Galacto-Oligosaccharides",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactic Acid",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Metafolin",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skim Milk",
            "Organic Whey",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Lactose",
            "Organic Galacto-Oligosaccharides (Obtained From Organic Lactose)",
            "Whey Protein",
            "Fish Oil",
            "Calcium Chloride",
            "Potassium Citrate",
            "Choline",
            "Mortierella Alpina Oil (ARA)",
            "Sodium Citrate",
            "L-Phenylalanine",
            "Calcium Salts of Orthophosphoric Acid",
            "Magnesium Sulfate",
            "L-Tryptophan",
            "Zinc Sulfate",
            "Iron Sulfate",
            "Lactic Acid",
            "Vitamin C",
            "Lactic Acid Culture [Hereditum Lactobacillus Fermentum CECT5716]",
            "Vitamin E",
            "Niacin (Vitamin B3)",
            "Pantothenic acid (Vitamin B5)",
            "Copper Sulfate",
            "Calcium Carbonate",
            "Vitamin A",
            "Vitamin B1",
            "Potassium Iodate",
            "Vitamin B6",
            "Metafolin (Calcium L-Methylfolate)",
            "Sodium Selenate",
            "Vitamin K",
            "Manganese Sulfate",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HiPPDutchStage101_1200x.jpg",
         "reviews_count":515,
         "stage":"1",
         "brand_collection":"HiPP Dutch"
      }
   ],
   "Kabrita":[
      {
         "name":"Kabrita Goat Milk Formula Stage 3",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/kabrita-stage-3",
         "ingredients":[
            "ARA",
            "Calcium",
            "Vitamin D3",
            "Taurine",
            "Choline",
            "Copper",
            "Vitamin E",
            "DHA",
            "Glucose Syrup",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Whey Powder",
            "Inositol",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Manganese",
            "Nicotinamide",
            "Palm Oil",
            "Potassium",
            "Vitamin C",
            "Sodium",
            "Soybean Oil",
            "Sunflower Oil",
            "Citric Acid",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Biotin",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products, soy products",
         "original_ingredients":[
            "Whole goat milk powder",
            "lactose from milk",
            "high sn-2 palmitic acid oil",
            "soybean oil",
            "palm kernel oil",
            "sunflower Oil",
            "skimmed goat milk",
            "goat whey protein concentrate powder (milk)",
            "dried glucose syrup",
            "galacto-oligosaccharides (GOS) from milk",
            "fructo-oligosaccharides (FOS)",
            "minerals (tricalcium phosphate",
            "trisodium citrate",
            "calcium carbonate",
            "potassium hydroxide",
            "tricalcium phosphate",
            "iron sulfate",
            "zinc sulfate",
            "copper sulfate",
            "manganese sulfate",
            "potassium iodide",
            "sodium selenate",
            "docosahexaenoic acid rich oil (DHA)",
            "choline bitartrate",
            "arachidonic acid oil (AA)",
            "L-ascorbic acid",
            "DL-α-tocopheryl acetate",
            "nicotinamide",
            "sodium L-ascorbate",
            "nicotinamide",
            "calcium D-pantothenate",
            "thiamine hydrochloride",
            "riboflavin",
            "retinyl acetate",
            "pyridoxine hydrochloride",
            "folic acid",
            "phytomenadione",
            "D-biotol",
            "cholecalcalcalin",
            "taurine",
            "choline chloride",
            "inositol",
            "L-carnitine L-tartrate"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/KabritaGoatStage301_1200x.jpg",
         "reviews_count":5,
         "stage":"3",
         "brand_collection":"Kabrita Goat"
      },
      {
         "name":"Kabrita Goat Milk Formula Stage 2",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/kabrita-stage-2",
         "ingredients":[
            "ARA",
            "Choline",
            "Copper",
            "Vitamin B12",
            "Vitamin E",
            "DHA",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Whey Powder",
            "Beta-Palmitate",
            "Iron",
            "Lactose",
            "Amino Acids",
            "Emulsifiers",
            "Magnesium",
            "Manganese",
            "Calcium",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Citric Acid",
            "Coconut Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Skimmed goat's milk",
            "lactose from milk",
            "coconut oil",
            "rapeseed oil",
            "sunflower Oil",
            "high sn-2 palmitic acid oil",
            "goat whey protein concentrate powder from milk",
            "galacto-oligosaccharides (GOS) from milk",
            "minerals (calcium carbonate",
            "tricalcium phosphate",
            "tripotassium citrate",
            "trisodium citrate",
            "sodium chloride",
            "potassium hydroxide",
            "potassium chloride",
            "magnesium chloride",
            "iron sulfate",
            "zinc sulfate",
            "copper sulfate",
            "manganese sulfate",
            "potassium iodide",
            "sodium selenate",
            "docosahexaenoic acid rich oil (DHA)",
            "choline bitartrate",
            "arachidonic acid rich oil (AA)",
            "sodium ascorbate",
            "L-ascorbic acid",
            "DL-α-tocopheryl acetate",
            "niacinamide",
            "calcium D-pantothenate",
            "riboflavin",
            "thiamine hydrochloride",
            "retinyl acetate",
            "pyridoxine hydrochloride",
            "folic acid",
            "phytomenadione",
            "cholecalciferol",
            "D-biotin",
            "cyanocobalamine",
            "laurolan",
            "Lositin",
            "laurol-carnitine L-tartrate"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/KabritaGoatStage201_1200x.jpg",
         "reviews_count":20,
         "stage":"2",
         "brand_collection":"Kabrita Goat"
      },
      {
         "name":"Kabrita Goat Milk Formula Stage 1",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/kabrita-goat-milk-formula",
         "ingredients":[
            "ARA",
            "Vitamin C",
            "Choline",
            "Copper",
            "Vitamin B12",
            "Vitamin E",
            "DHA",
            "Folic Acid",
            "Galacto-Oligosaccharides",
            "Goat Milk",
            "Whey Powder",
            "Beta-Palmitate",
            "Inositol",
            "Amino Acids",
            "Iron",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Calcium",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Citric Acid",
            "Coconut Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin D3",
            "Vitamin K",
            "Biotin",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Skimmed goat milk",
            "lactose from milk",
            "coconut oil",
            "rapeseed oil",
            "sunflower Oil",
            "high sn-2 palmitic acid oil",
            "goat whey protein concentrate powder from milk",
            "galacto-oligosaccharides (GOS) from milk",
            "minerals (calcium carbonate",
            "tripotassium citrate",
            "trisodium citrate",
            "potassium hydroxide",
            "sodium chloride",
            "potassium chloride",
            "magnesium chloride",
            "iron sulfate",
            "zinc sulfate",
            "tricalcium phosphate",
            "copper sulfate",
            "manganese sulfate",
            "potassium iodide",
            "sodium selenate",
            "docosahexaenoic acid rich oil (DHA)",
            "choline bitartrate",
            "arachidonic acid (AA)",
            "ascorbic acid rich oil sodium L-ascorbate",
            "DL-α tocopheryl acetate",
            "niacinamide",
            "calcium D-pantothenate",
            "thiamine hydrochloride",
            "riboflavin",
            "pyridoxine hydrochloride",
            "retinyl acetate",
            "folic acid",
            "phytomenadione D-biotin",
            "cholecalciferol",
            "cyanocobalamin)",
            "L-Lositol-carnine-carnine",
            "in Lositolalauranine-tartrate",
            "L-tryptophan"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/KabritaGoatStage101_1200x.jpg",
         "reviews_count":16,
         "stage":"1",
         "brand_collection":"Kabrita Goat"
      }
   ],
   "Holle":[
      {
         "name":"Holle Goat Milk Formula Stage 4",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Stage_4_3b5c6822-ca67-446e-86e8-3d6060109968_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-goat-stage-4",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Citrate",
            "Sodium Citrate",
            "Oil from the Microalgae Schizochytrium Sp.2",
            "Vitamin C",
            "L-Tyrosine",
            "L-Cystine",
            "L-Tryptophan",
            "Magnesium Carbonate",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Vitamin E",
            "Pantothenic Acid",
            "Niacin",
            "Copper Sulfate",
            "Vitamin B1",
            "Vitamin A",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Vitamin K1",
            "Sodium Selenite",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HolleGoatStage402_360b5da6-d628-4f85-a8e9-99f4fdbb10bb_1200x.jpg",
         "reviews_count":143,
         "stage":"4",
         "brand_collection":"Holle Goat"
      },
      {
         "name":"Holle Goat Milk Formula Stage PRE",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Stage_PRE_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-goat-pre",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Calcium Carbonate",
            "Choline Bitartrate",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Oil from Mortierella Alpina",
            "Sodium Citrate",
            "Potassium Citrate",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tryptophan",
            "L-Cystine",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Pantothenic Acid",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Sodium Selenite",
            "Vitamin K1",
            "Vitamin B1",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HolleGoatPRE02_1200x.jpg",
         "reviews_count":259,
         "stage":"Pre",
         "brand_collection":"Holle Goat"
      },
      {
         "name":"Holle A2 Stage 3 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_A2_Stage_3_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-a2-stage-3",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Cow Milk",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains fish products, milk products",
         "original_ingredients":[
            "Organic Skimmed A2 Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium sp.2",
            "L-Tyrosine",
            "Vitamin C",
            "Calcium Salts of Orthophosphoric Acid",
            "Potassium Citrate",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Vitamin B1",
            "Folic acid",
            "Vitamin K",
            "Sodium Selenite",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioA2302_1200x.jpg",
         "reviews_count":61,
         "stage":"3",
         "brand_collection":"Holle A2"
      },
      {
         "name":"Holle A2 Stage 2 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_A2_Stage_2_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-a2-stage-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Cow Milk",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains fish products, milk products",
         "original_ingredients":[
            "Organic Skimmed A2 Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium sp.2",
            "L-Tyrosine",
            "Vitamin C",
            "Calcium Salts of Orthophosphoric Acid",
            "Potassium Citrate",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Vitamin E",
            "Magnesium Carbonate",
            "Niacin",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Thiamine",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Folic Acid",
            "Vitamin K",
            "Sodium Selenite",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioA2202_1200x.jpg",
         "reviews_count":90,
         "stage":"2",
         "brand_collection":"Holle A2"
      },
      {
         "name":"Holle A2 Stage 1 Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_A2_Stage_1_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-a2-stage-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Fish Oil",
            "Folic Acid",
            "Inositol",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Cow Milk",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains fish products, milk products",
         "original_ingredients":[
            "Organic Skimmed A2 Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Lactose",
            "Calcium Carbonate",
            "L-Tyrosine",
            "Potassium Chloride",
            "Fish Oil2",
            "Magnesium Chloride",
            "Mortierella Alpina Oil",
            "Calcium Chloride",
            "Calcium Hydroxide",
            "Choline",
            "Sodium Chloride",
            "L-Tryptophan",
            "Inositol",
            "Iron Lactate",
            "Vitamin C",
            "Zinc Sulfate",
            "Vitamin E",
            "Niacin",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B1",
            "Manganese Sulfate",
            "Vitamin B6",
            "Potassium Iodate",
            "Folic Acid",
            "Sodium Selenate",
            "Vitamin K",
            "Vitamin D",
            "Biotin"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/HolleBio1AnfangsmilchA202_1200x.jpg",
         "reviews_count":92,
         "stage":"1",
         "brand_collection":"Holle A2"
      },
      {
         "name":"Holle Goat Dutch Formula Stage 3",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Dutch_Stage_3.jpg",
         "url":"https://organiclifestart.com/products/holle-goat-dutch-stage-3-organic-toddler-formula",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin (from Corn)",
            "Organic starch",
            "Calcium Carbonate",
            "Oil Extracted from the Microalgae Schizochytrium Sp.2",
            "Sodium Citrate",
            "Potassium Citrate",
            "Vitamin C",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Cystine",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Pantothenic Acid",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin B1-Thiamine",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleGoatDutchStage301_d82eddcf-459f-40da-854a-74282f8345d3_1200x.jpg",
         "reviews_count":161,
         "stage":"3",
         "brand_collection":"Holle Goat Dutch"
      },
      {
         "name":"Holle Goat Dutch Formula Stage 2",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Dutch_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/holle-goat-dutch-stage-2-organic-follow-on-infant-milk-formula",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin (from Corn)",
            "Organic starch",
            "Calcium Carbonate",
            "Oil Extracted from the Microalgae Schizochytrium Sp.2",
            "Sodium Citrate",
            "Potassium Citrate",
            "Vitamin C",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Cystine",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Pantothenic Acid",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin A",
            "Vitamin B1-Thiamine",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Sodium Selenite",
            "Vitamin K",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleGoatDutchStage201_3c16b1ae-aae8-4404-b0f3-a3652da34adb_1200x.jpg",
         "reviews_count":177,
         "stage":"2",
         "brand_collection":"Holle Goat Dutch"
      },
      {
         "name":"Holle Goat Dutch Milk Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Dutch_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/holle-dutch-formula",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Magnesium",
            "Choline",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Manganese",
            "Mortierella Alpina Oil",
            "Algae Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Calcium Carbonate",
            "Choline Bitartrate",
            "Oil extracted from the Schizochytrium Microalgae Sp.2",
            "Mortierella Alpina Oil",
            "Sodium Citrate",
            "Potassium Citrate",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tryptophan",
            "L-Cystine",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Carbonate Magnesium",
            "Pantothenic Acid",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin A",
            "Vitamin B1-Thiamine",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Sodium Selenite",
            "Vitamin K",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleGoatDutchStage101_3_1200x.jpg",
         "reviews_count":215,
         "stage":"1",
         "brand_collection":"Holle Goat Dutch"
      },
      {
         "name":"Holle Goat Milk Formula Stage 3",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Stage_3_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-goat-milk-formula-stage-3",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Sodium Citrate",
            "Potassium Citrate",
            "Vitamin C",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Cystine",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Pantothenic Acid",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Vitamin A",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Sodium Selenite",
            "Vitamin K1",
            "Vitamin B1",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleGoatStage302_24c277de-a673-4da3-a4b7-357dfac5d9f2_1200x.jpg",
         "reviews_count":170,
         "stage":"3",
         "brand_collection":"Holle Goat"
      },
      {
         "name":"Holle Goat Milk Formula Stage 2",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Stage_2_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-goat-milk-formula-stage-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Sodium Citrate",
            "Potassium Citrate",
            "Vitamin C",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Cystine",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Pantothenic Acid",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Folic Acid",
            "Manganese Sulfate",
            "Sodium Selenite",
            "Vitamin K1",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleGoatStage202_408cdc9e-3992-4a90-b2a1-283803423e07_1200x.jpg",
         "reviews_count":203,
         "stage":"2",
         "brand_collection":"Holle Goat"
      },
      {
         "name":"Holle Stage PRE Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Goat_Stage_PRE_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-pre-formula",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Products (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Lactose",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Oil from Mortierella Alpina",
            "Choline Bitartrate",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tyrosine",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Vitamin B1",
            "Folic Acid",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioStagePRE02_8dcce480-d1b1-4f38-b696-2ca9b4c103f6_1200x.jpg",
         "reviews_count":137,
         "stage":"Pre",
         "brand_collection":"Holle Bio"
      },
      {
         "name":"Holle Stage 4 Organic Toddler Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Bio_Stage_4_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-stage-4",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Potassium Chloride",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tyrosine",
            "Sodium Chloride",
            "L-Tryptophan",
            "Magnesium Carbonate",
            "Iron Sulfate",
            "Vitamin E",
            "Zinc Sulfate",
            "Niacin",
            "Pantothenic Acid",
            "Copper Sulfate",
            "Vitamin B1",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Potassium Iodide",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioStage402_1200x.jpg",
         "reviews_count":131,
         "stage":"4",
         "brand_collection":"Holle Bio"
      },
      {
         "name":"Holle Stage 3 Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Bio_Stage_3_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-bio-stage-3",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Products (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Vitamin C",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Tyrosine",
            "Potassium Citrate",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Vitamin B1",
            "Folic Acid",
            "Vitamin K",
            "Sodium Selenite",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioStage302_1200x.jpg",
         "reviews_count":135,
         "stage":"3",
         "brand_collection":"Holle Bio"
      },
      {
         "name":"Holle Stage 2 Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Bio_Stage_2_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-bio-stage-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Products (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Vitamin C",
            "Calcium Salts of Orthophosphoric Acid",
            "L-Tyrosine",
            "Potassium Citrate",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Vitamin E",
            "Magnesium Carbonate",
            "Niacin",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Folic Acid",
            "Vitamin K",
            "Sodium Selenite",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioStage202_8e58fade-1d37-4ef9-8cd7-cd0fda31760a_1200x.jpg",
         "reviews_count":172,
         "stage":"2",
         "brand_collection":"Holle Bio"
      },
      {
         "name":"Holle Stage 1 Organic Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Holle_Bio_Stage_1_1200x.jpg",
         "url":"https://organiclifestart.com/products/holle-bio-stage-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Products (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Lactose",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Oil from Mortierella Alpina",
            "Choline Bitartrate",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tyrosine",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Vitamin E",
            "Magnesium Carbonate",
            "Niacin",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Folic Acid",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleBioStage102_f88441c5-d6e6-4f7b-bb84-c330081e8ec2_1200x.jpg",
         "reviews_count":199,
         "stage":"1",
         "brand_collection":"Holle Bio"
      },
      {
         "name":"Holle Goat Milk Formula Stage 1",
         "ingredients_image":null,
         "url":"https://organiclifestart.com/products/holle-goat-stage-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Folic Acid",
            "Goat Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Sunflower Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products",
         "original_ingredients":[
            "Organic Whole Goat's Milk",
            "Organic Lactose",
            "Organic Whole Goat's Milk Powder",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Calcium Carbonate",
            "Choline Bitartrate",
            "Oil from the Microalgae Schizochytrium sp.2",
            "Oil from Mortierella Alpina",
            "Sodium Citrate",
            "Potassium Citrate",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tryptophan",
            "L-Cystine",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Pantothenic Acid",
            "Niacin",
            "Copper Sulfate",
            "Vitamin E",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B6",
            "Manganese Sulfate",
            "Folic Acid",
            "Sodium Selenite",
            "Vitamin K1",
            "Potassium Iodide",
            "Biotin",
            "Vitamin D",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/HolleGoatStage102_f55c7e6d-1060-465e-82c7-4e021674fc3f_1200x.jpg",
         "reviews_count":327,
         "stage":"1",
         "brand_collection":"Holle Goat"
      }
   ],
   "Nannycare":[
      {
         "name":"Nannycare Stage 3 Goat Milk Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Nannycare_Stage_3_491e391d-3d57-4011-8089-dc31494a6a6b.jpg",
         "url":"https://organiclifestart.com/products/nannycare-3",
         "ingredients":[
            "Sunflower Lecithin",
            "Calcium",
            "Choline",
            "Copper",
            "Vitamin B12",
            "Vitamin A",
            "Iron",
            "Folic Acid",
            "Amino Acids",
            "Lactose",
            "Potassium",
            "Fish Oil",
            "Nicotinamide",
            "Goat Milk",
            "Vitamin K",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Taurine",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Pasteurized Whole Goat Milk",
            "Lactose (from Milk)",
            "Vegetable Oil Blend (High Oleic Sunflower Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Antioxidants (Sunflower Lecithin",
            "Tocopherol-Rich Extract)",
            "Pasteurized Goat Milk Powders",
            "Marine Fish Oil Powder (Source of Docosahexaenoic Acid)",
            "Minerals",
            "Choline Chloride",
            "L-Tyrosine",
            "L-Tryptophan",
            "L-Cystine",
            "Vitamins",
            "L-Isoleucine",
            "Taurine",
            "L-Carnitine",
            "Dl-A-Tocopheryl Acetate",
            "L-Ascorbic Acid",
            "Nicotinamide",
            "Cholecalciferol",
            "Retinyl Acetate",
            "Calcium D-Pantothenate",
            "Cyanocobalamin",
            "Phytonadione",
            "Thiamin Hydrochloride",
            "Riboflavin",
            "Pyridoxine Hydrochloride",
            "Folic Acid",
            "D-Biotin",
            "Dicalcium Phosphate",
            "Sodium Citrate",
            "Calcium Citrate",
            "Calcium Hydroxide",
            "Potassium Chloride",
            "Ferrous Sulfate",
            "Zinc Sulfate",
            "Copper Sulfate",
            "Manganese Sulfate Potassium Iodide",
            "Sodium Selenite"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/NannycareGoatStage301_1200x.jpg",
         "reviews_count":145,
         "stage":"3",
         "brand_collection":"Nannycare Goat"
      },
      {
         "name":"Nannycare Stage 2 Goat Milk Formula",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Nannycare_Stage_2_c9517141-2644-441d-83fa-849a9f4af171.jpg",
         "url":"https://organiclifestart.com/products/nannycare-stage-2",
         "ingredients":[
            "Sunflower Lecithin",
            "Calcium",
            "Choline",
            "Copper",
            "Vitamin B12",
            "Iron",
            "Folic Acid",
            "Vitamin A",
            "Amino Acids",
            "Lactose",
            "Manganese",
            "Fish Oil",
            "Mortierella Alpina Oil",
            "Nicotinamide",
            "Goat Milk",
            "Vitamin K",
            "Potassium",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Taurine",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Pasteurized Whole Goat Milk",
            "Lactose (from Milk)",
            "Vegetable Oil Blend (High Oleic Sunflower Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "Antioxidants (Sunflower Lecithin",
            "Tocopherol-Rich Extract)",
            "Pasteurized Goat Milk Powders",
            "Marine Fish Oil Powder (Source of Docosahexaenoic Acid)",
            "Mortierella Alpina Oil Powder (Source of Docosahexaenoic Acid)",
            "Minerals",
            "Choline Chloride",
            "L-Tyrosine",
            "L-Tryptophan",
            "L-Cystine",
            "Vitamins",
            "L-Isoleucine",
            "Taurine",
            "L-Carnitine. Dl-A-Tocopheryl Acetate",
            "L-Ascorbic Acid",
            "Nicotinamide",
            "Cholecalciferol",
            "Retinyl Acetate",
            "Calcium D-Pantothenate",
            "Cyanocobalamin",
            "Phytonadione",
            "Thiamin Hydrochloride",
            "Riboflavin",
            "Pyridoxine Hydrochloride",
            "Folic Acid",
            "D-Biotin",
            "Sodium Citrate",
            "Dicalcium Phosphate",
            "Calcium Citrate",
            "Calcium Hydroxide",
            "Potassium Chloride",
            "Ferrous Sulfate",
            "Zinc Sulfate",
            "Copper Sulfate",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Sodium Selenite"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/NannycareGoatStage201_1200x.jpg",
         "reviews_count":145,
         "stage":"2",
         "brand_collection":"Nannycare Goat"
      },
      {
         "name":"Nannycare Goat Milk Formula Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Nannycare_Stage_1_9a2079e4-4dce-46b0-9ebf-29f1a1879b4e.jpg",
         "url":"https://organiclifestart.com/products/nannycare-stage-1",
         "ingredients":[
            "Sunflower Lecithin",
            "Calcium",
            "Choline",
            "Copper",
            "Vitamin B12",
            "Iron",
            "Folic Acid",
            "Amino Acids",
            "Vitamin A",
            "Lactose",
            "Manganese",
            "Fish Oil",
            "Mortierella Alpina Oil",
            "Nicotinamide",
            "Goat Milk",
            "Vitamin K",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Sunflower Oil",
            "Taurine",
            "Vitamin B1",
            "Vitamin B2",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Biotin",
            "Vitamin E",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Pasteurized Whole Goat Milk",
            "Lactose (from Milk)",
            "Vegetable Oil Blend (High Oleic Sunflower Oil",
            "Rapeseed Oil",
            "Sunflower Oil",
            "and Antioxidants (Sunflower Lecithin",
            "Tocopherol-Rich Extract). Pasteurized Goat Milk Powders",
            "Marine Fish Oil Powder (Source of Docosahexaenoic Acid)",
            "Mortierella Alpina Oil Powder (Source of Arachidonic Acid)",
            "Minerals",
            "Choline Chloride",
            "L-Tyrosine",
            "L-Tryptophan",
            "L-Cystine",
            "Vitamins",
            "L-Isoleucine",
            "Taurine",
            "L-Carnitine",
            "L-A-Tocopheryl Acetate",
            "L-Ascorbic Acid",
            "Nicotinamide",
            "Cholecalciferol",
            "Retinyl Acetate",
            "Calcium D-Pantothenate",
            "Cyanocobalamin",
            "Phytonadione",
            "Thiamin Hydrochloride",
            "Riboflavin",
            "Pyridoxine Hydrochloride",
            "Folic Acid",
            "D-Biotin",
            "Sodium Citrate",
            "Calcium Citrate",
            "Calcium Hydroxide",
            "Potassium Chloride",
            "Ferrous Sulfate",
            "Zinc Sulfate",
            "Copper Sulfate",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Sodium Selenite"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/products/NannycareGoatStage101_1200x.jpg",
         "reviews_count":145,
         "stage":"1",
         "brand_collection":"Nannycare Goat"
      }
   ],
   "Lebenswert":[
      {
         "name":"Lebenswert Organic Baby Formula Stage 3",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Lebenswert_Stage_3.jpg",
         "url":"https://organiclifestart.com/products/lebenswert-stage-3",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Orthophosphoric Acid",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil from the Microalgae Schizochytrium Sp.2",
            "L-Tyrosine",
            "Vitamin C",
            "Calcium Salts",
            "Orthophosphoric Acid",
            "Potassium Citrate",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Magnesium Carbonate",
            "Niacin",
            "Vitamin E",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Thiamine",
            "Folic Acid",
            "Vitamin K",
            "Sodium Selenite",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/LebenswertAnfangsmilchStage302_1200x.jpg",
         "reviews_count":120,
         "stage":"3",
         "brand_collection":"Lebenswert Organic"
      },
      {
         "name":"Lebenswert Organic Baby Formula Stage 2",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Lebenswert_Stage_2.jpg",
         "url":"https://organiclifestart.com/products/lebenswert-stage-2",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Magnesium",
            "Maltodextrin",
            "Manganese",
            "Algae Oil",
            "Potassium",
            "Rapeseed Oil",
            "Sodium",
            "Starch",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Sunflower Oil",
            "Organic Rapeseed Oil",
            "Organic Maltodextrin",
            "Organic Starch",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil From The Microalga Schizochytrium Sp.2",
            "L-Tyrosine",
            "Vitamin C",
            "Calcium Salts of Orthophosphoric Acid",
            "Potassium Citrate",
            "Sodium Chloride",
            "L-Tryptophan",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Vitamin E",
            "Magnesium Carbonate",
            "Niacin",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Thiamine",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Folic Acid",
            "Vitamin K",
            "Sodium Selenite",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/LebenswertAnfangsmilchStage202_1200x.jpg",
         "reviews_count":146,
         "stage":"2",
         "brand_collection":"Lebenswert Organic"
      },
      {
         "name":"Lebenswert Organic Baby Formula Stage 1",
         "ingredients_image":"https://cdn.shopify.com/s/files/1/0598/7909/6503/files/Lebenswert_Stage_1.jpg",
         "url":"https://organiclifestart.com/products/lebenswert-stage-1",
         "ingredients":[
            "Biotin",
            "Calcium",
            "Choline",
            "Copper",
            "Folic Acid",
            "Cow Milk",
            "Iron",
            "Amino Acids",
            "Lactose",
            "Magnesium",
            "Manganese",
            "Mortierella Alpina Oil",
            "Potassium",
            "Rapeseed Oil",
            "Algae Oil",
            "Sodium",
            "Sunflower Oil",
            "Palm Oil",
            "Vitamin A",
            "Vitamin B1",
            "Vitamin B12",
            "Vitamin B3",
            "Vitamin B5",
            "Vitamin B6",
            "Vitamin C",
            "Vitamin D3",
            "Vitamin E",
            "Vitamin K",
            "Whey Powder",
            "Zinc"
         ],
         "allergens":"Contains milk, milk products, fish products",
         "original_ingredients":[
            "Organic Skimmed Milk",
            "Organic Whey Product (Partially Demineralized Whey Powder)",
            "Organic Palm Oil",
            "Organic Rapeseed Oil",
            "Organic Sunflower Oil",
            "Organic Lactose",
            "Calcium Carbonate",
            "Potassium Chloride",
            "Oil From the Microalgae Schizochytrium Sp.2",
            "Oil From Mortierella Alpina",
            "Choline Hydrogen Tartrate",
            "L-Tyrosine",
            "Calcium Salts of Orthophosphoric Acid",
            "Vitamin C",
            "L-Tryptophan",
            "Sodium Chloride",
            "Iron Sulfate",
            "Zinc Sulfate",
            "Vitamin E",
            "Magnesium Carbonate",
            "Niacin",
            "Copper Sulfate",
            "Pantothenic Acid",
            "Vitamin A",
            "Thiamine",
            "Vitamin B6",
            "Manganese Sulfate",
            "Potassium Iodide",
            "Folic Acid",
            "Sodium Selenite",
            "Vitamin K",
            "Vitamin D",
            "Biotin",
            "Vitamin B12"
         ],
         "product_image":"https://organiclifestart.com/cdn/shop/files/LebenswertAnfangsmilchStage102_1200x.jpg",
         "reviews_count":146,
         "stage":"1",
         "brand_collection":"Lebenswert Organic"
      }
   ]
};